import { Button, Form, message, Upload, FormInstance } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import { FileValidator } from '../file-upload/file-validator';
import { RcFile} from 'antd/lib/upload/interface';


export const PhotoUpload: React.FC<{ name: string; label: string; form: FormInstance; cropperProps?: object }> = ({ name, label, form, cropperProps }) => {
  const uploadProps = {
    beforeUpload: async (file: RcFile) => {
      const validator = new FileValidator(file, {
        permittedContentTypes: ['image/jpeg', 'image/png', 'image/jpg']
      });
    
      const result = await validator.validate();
      if (result.success) {
        form.setFieldsValue({ [name]: { originFileObj: result.file } });
        return false;
      }
    
      return Upload.LIST_IGNORE;
    },
    maxCount: 1,
    onChange: (info: any) => {
      if (info.file.status === 'removed') {
        form.setFieldsValue({ [name]: undefined });
      }
    },
  };

  const beforeCrop = async (file: RcFile) => {
    const validator = new FileValidator(file, {
      permittedContentTypes: ['image/jpeg', 'image/png', 'image/jpg']
    });
  
    const result = await validator.validate();
    if (!result.success) {
      message.error(result.code === 'content-type' 
        ? 'Files of that content type are not permitted'
        : result.message);
      return false;
    }
  
    return true;
  };

  return (
    <Form.Item
      label={label}
      name={name}
      rules={[{ required: true, message: `Please upload ${label}` }]}
    >
      <ImgCrop {...{...cropperProps, beforeCrop}}>
        <Upload {...uploadProps} listType="picture">
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
      </ImgCrop>
    </Form.Item>
  );
};